<style lang="less" scoped>
.ivu-table .demo-table-info-row td {
  background-color: #ccc;
}

.ivu-table .demo-table-error-row td {
  color: #000;
}

/*#tabPanel .active {*/
/*  background: #eee;*/
/*}*/
/*#tabPanel {*/
/*  height: 340px;*/
/*  width: 500px;*/
/*  margin: 100px auto;*/
/*}*/
/*#tabPanel .tab {*/
/*  height: 40px;*/
/*  background: #ccc;*/
/*  margin-top: 10px;*/
/*}*/
/*#tabPanel .tab ul li {*/
/*  list-style: none;*/
/*  float: left;*/
/*  width: 80px;*/
/*  height: 40px;*/
/*  text-align: center;*/
/*  line-height: 40px;*/
/*}*/
/*#tabPanel .content {*/
/*  height: 300px;*/
/*  width: 500px;*/
/*  background: #eee;*/
/*}*/
.wrapper-header-nav-list {
  height: inherit;
  /*float: right;*/
}

.ivu-menu-item {
  display: block;
  outline: 0;
  list-style: none;
  font-size: 14px;
  /*position: relative;*/
  /*z-index: 1;*/
  /*cursor: pointer;*/
  /*transition: all .2s ease-in-out;*/
}

.wrapper-content {
  padding: 20px 0px;
  position: relative;
}

.wrapper {
  background: #eee;
  padding: 1px;
}

.wrapper-header {
  /*position: fixed;*/
  /*width: 100%;*/
  /*top: 0;*/
  /*right: 0;*/
  /*z-index: 1000;*/
}

.wrapper-header .ivu-menu-horizontal {
  height: 65px;
  line-height: 65px;
}

.wrapper-header .ivu-menu {
  /*z-index: 901;*/
  box-shadow: 0 1px 1px rgba(0, 0, 0, .08);
}

.ivu-menu-light {
  background: #fff;
}

.ivu-menu-horizontal {
  height: 60px;
  line-height: 60px;
}

.wrapper-container {
  background: #fff;
  /*margin: 80px auto 15px;*/
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, .1);
}

.ivu-row {
  position: relative;
  margin-left: 0;
  margin-right: 0;
  height: auto;
  zoom: 1;
  display: block;
}

.ivu-col-span-17 {
  display: block;
  width: 70.83333333%;
}

.wrapper-content {
  padding: 20px 5px;
  position: relative;
}

.ivu-menu-item-selected {
  background: red;
}

.ivu-menu-light.ivu-menu-horizontal .ivu-menu-item-active {
  color: #2d8cf0;
  border-bottom: 2px solid #2d8cf0;
}

.red-point {
  position: relative;
}

.red-point::before {
  content: " ";
  border: 3px solid red; /*设置红色*/
  border-radius: 3px; /*设置圆角*/
  position: absolute;
  /*z-index: 1000;*/
  right: 0%;
  margin-right: -5px;
  margin-top: -5px;
}
</style>
<template>
  <div>
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">个人邮箱</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="wrapper">
      <div class="wrapper-header">
        <ul class="ivu-menu ivu-menu-light ivu-menu-horizontal">
          <div id="tabPanel" class="wrapper-header-nav-list">
               
            <li v-for="(value, index) in labelList" class="ivu-menu-item"
                v-bind:class="{'ivu-menu-item-active': index === tabName}"
                v-on:click="getMessage(index)">
              {{ value }}
              <span class="ivu-badge" v-for="(countObj, countIndex) in tabCountStatistic"
                    v-if="index === countObj.tabName && countObj.count > 0">
              <sup class="ivu-badge-dot"></sup>
            </span>
            </li>
          </div>
        </ul>
      </div>
      <div class="wrapper-container">
        <div class="ivu-row">
          <div class="wrapper-content ivu-article">
            <div style="margin-bottom: 12px">
              <Input v-model="keyword" placeholder="学生ID / 姓名 / 提醒内容" clearable style="width: 280px" @on-enter="searchMessage" @on-clear="searchMessage"></Input>
              <Button type="primary" style="margin-left: 8px" @click="searchMessage">搜索</Button>
            </div>
            <i-table :columns="columnList" :data="currentPersonMessageList" :row-class-name="rowClassName"></i-table>
            <div style="margin-top: 12px; text-align: right">
              <Page :total="totalCount" :current="pageIndex" :page-size="pageSize"
                    show-total show-sizer @on-change="onPageChange" @on-page-size-change="onPageSizeChange"></Page>
            </div>
          </div>
        </div>
      </div>
    </div>
    <change-director-modal :value="openModal" @on-close="openModal=false" :data="editData"></change-director-modal>
    <ShowImageCarousel :imgList="showImgList" :value="showImgModal" @on-close="closeImgModal"></ShowImageCarousel>
  </div>
</template>
<script>
import commonUtils from '@/tools/commonUtils.js'
import bus from '@/eventBus.js'
import ChangeDirectorModal from '../user/ChangeDirectorModal'
import ShowImageCarousel from '../order/ShowImageCarousel'

export default {
  components: {ShowImageCarousel, ChangeDirectorModal},
  data () {
    let $moment = this.$moment
    return {
      showImgModal: false,
      showImgList: [],
      tabName: 0,
      tabItem: '',
      tabContent: '',
      labelList: ['新注册学生', '分配记录', '试听课记录', '成交记录', '交接记录', '绑定记录', '上课跟进记录', '其他'],
      tabCountStatistic: [],
      labelNumList: [],
      currentPersonMessageList: [],
      pageIndex: 1,
      pageSize: 20,
      totalCount: 0,
      keyword: '',
      totalPersonMessageList: [],
      columnList: [
        {
          title: '学生ID/姓名',
          width: 150,
          render: (h, params) => {
            let row = params.row
            return h('span', row.uid + '-' + row.nickname)
          }
        },
        {
          title: '提醒内容',
          width: 400,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            // 将换行符替换为<br>标签
            const formattedContent = params.row.content.replace(/\n/g, '<br>')

            if (row.state === 0) {
              const children = [
                h('div', {
                  domProps: {
                    innerHTML: formattedContent
                  },
                  style: {
                    textAlign: 'left'
                  }
                }),
              ]

              // 只有当 row.urls 不为空时才添加查看附件链接
              if (row.urls && row.urls.length > 0) {
                children.push(h('Badge', [
                  h('sub', {
                    class: 'ivu-badge-dot'
                  })
                ]))
                children.push(h('a', {on: {click: () => this.viewPic(row)}}, '查看附件'))
              }

              return h('div', children)
            } else {
              return h('div', {
                domProps: {
                  innerHTML: formattedContent
                },
                style: {
                  textAlign: 'left'
                }
              })
            }
          }
        },
        {
          title: '提醒时间',
          align: 'center',
          render: (h, params) => {
            let createTime = params.row.createTime
            return h('span', $moment(createTime, 'X').format('YYYY-MM-DD HH:ss'))
          }
        },
        {
          title: '操作',
          align: 'center',
          render: (h, params) => {
            let row = params.row
            let btnArr = []
            if (row.state === 0) {
              let type = row.type
              let typeNum = commonUtils.getShortNumByTraceType(type)
              if (typeNum === 0 || typeNum === 5 || typeNum === 1 || type === 64 || type === 63 || type === 65 || type === 52 || type === 51 || type === 71) {
                btnArr.push(h('Button', {
                  props: {type: 'primary'},
                  on: {click: () => this.updateTraceOperatorStatus(row)}
                }, '已读'))
              } else if (type === 21) {
                btnArr.push(h('Button', {
                  props: {type: 'primary'},
                  on: {click: () => this.goOnNextStep(row)}
                }, '填写学员消息'))
                btnArr.push(h('span', '        '))
                btnArr.push(h('Button', {
                  props: {type: 'primary'},
                  on: {click: () => this.updateTraceOperatorStatusAlert(row)}
                }, '已操作'))
              } else if (type === 24) {
                btnArr.push(h('Button', {
                  props: {type: 'primary'},
                  on: {click: () => this.goOnNextStep(row)}
                }, '填写试听课反馈'))
                btnArr.push(h('span', '        '))
                btnArr.push(h('Button', {
                  props: {type: 'primary'},
                  on: {click: () => this.updateTraceOperatorStatusAlert(row)}
                }, '已操作'))
              } else if (type === 23) {
                btnArr.push(h('Button', {
                  props: {type: 'primary'},
                  on: {click: () => this.goOnNextStep(row)}
                }, '填写试听课缺席原因'))
                btnArr.push(h('span', '        '))
                btnArr.push(h('Button', {
                  props: {type: 'primary'},
                  on: {click: () => this.updateTraceOperatorStatusAlert(row)}
                }, '已操作'))
              } else if (type === 42) {
                btnArr.push(h('Button', {
                  props: {type: 'primary'},
                  on: {click: () => this.goOnNextStep(row)}
                }, '填写家长沟通记录'))
                btnArr.push(h('span', '        '))
                btnArr.push(h('Button', {
                  props: {type: 'primary'},
                  on: {click: () => this.updateTraceOperatorStatusAlert(row)}
                }, '已操作'))
              } else if (type === 41) {
                btnArr.push(h('Button', {
                  props: {type: 'primary'},
                  on: {click: () => this.goOnNextStep(row)}
                }, '填写教材配送信息'))
                btnArr.push(h('span', '        '))
                btnArr.push(h('Button', {
                  props: {type: 'primary'},
                  on: {click: () => this.updateTraceOperatorStatusAlert(row)}
                }, '已操作'))
              } else if (type === 43) {
                btnArr.push(h('Button', {
                  props: {type: 'primary'},
                  on: {click: () => this.goOnNextStep(row)}
                }, '填写家长沟通记录'))
                btnArr.push(h('span', '        '))
                btnArr.push(h('Button', {
                  props: {type: 'primary'},
                  on: {click: () => this.updateTraceOperatorStatusAlert(row)}
                }, '已操作'))
              } else if (type === 22) {
                btnArr.push(h('Button', {
                  props: {type: 'primary'},
                  on: {click: () => this.goOnNextStep(row)}
                }, '填写试听课失败原因'))
                btnArr.push(h('span', '        '))
                btnArr.push(h('Button', {
                  props: {type: 'primary'},
                  on: {click: () => this.updateTraceOperatorStatusAlert(row)}
                }, '已操作'))
              } else if (type === 25) {
                btnArr.push(h('Button', {
                  props: {type: 'primary'},
                  on: {click: () => this.goOnNextStep(row)}
                }, '学员是否报名'))
                btnArr.push(h('span', '        '))
                btnArr.push(h('Button', {
                  props: {type: 'primary'},
                  on: {click: () => this.updateTraceOperatorStatusAlert(row)}
                }, '已操作'))
              } else if (type === 66) {
                btnArr.push(h('Button', {
                  props: {type: 'primary'},
                  on: {click: () => this.goOnNextStep(row)}
                }, '开课日期是否生效'))
                btnArr.push(h('span', '        '))
                btnArr.push(h('Button', {
                  props: {type: 'primary'},
                  on: {click: () => this.updateTraceOperatorStatusAlert(row)}
                }, '已操作'))
              } else {
                btnArr.push(h('Button', {
                  props: {type: 'primary'},
                  on: {click: () => this.goOnNextStep(row)}
                }, '下一步'))
                btnArr.push(h('span', '        '))
                btnArr.push(h('Button', {
                  props: {type: 'primary'},
                  on: {click: () => this.updateTraceOperatorStatusAlert(row)}
                }, '已操作'))
              }
            }

            return h('div', btnArr)
          }
        },
      ],
      openModal: false,
      editData: null
    }
  },
  mounted: function () {
  },
  created: function () {
    let self = this
    if (self.$route.query.tabName) {
      self.tabName = self.$route.query.tabName
    }
    self.getAllTypesNewPersonMessageCount()
    self.getMessage(self.tabName)
  },
  methods: {
    searchMessage () {
      this.pageIndex = 1
      this.getMessage(this.tabName, true)
    },
    getMessage (index, keepPage, retried) {
      let self = this
      index = Number(index)
      if (isNaN(index)) {
        index = 0
      }
      self.tabName = index
      if (!keepPage) {
        self.pageIndex = 1
      }
      self.currentPersonMessageList = []
      let typeList = commonUtils.getTraceTypeListByShortNum(index) || []
      let queryList = []
      for (let i = 0; i < typeList.length; i++) {
        queryList.push('messageTypeList=' + typeList[i])
      }
      queryList.push('pageIndex=' + self.pageIndex)
      queryList.push('pageSize=' + self.pageSize)
      let keyword = (self.keyword || '').trim()
      if (keyword) {
        queryList.push('keyword=' + encodeURIComponent(keyword))
      }
      self.$http.get('/message/getPersonMessage?' + queryList.join('&')).then(function (res) {
        let payload = (res && res.data) ? res.data : {}
        let list = payload.data || []
        self.currentPersonMessageList = list
        self.totalCount = payload.totalCount || 0
        if (list.length === 0 && self.pageIndex > 1 && !retried) {
          self.pageIndex = self.pageIndex - 1
          self.getMessage(self.tabName, true, true)
        }
      })
    },
    onPageChange (page) {
      this.pageIndex = page
      this.getMessage(this.tabName, true)
    },
    onPageSizeChange (size) {
      this.pageSize = size
      this.pageIndex = 1
      this.getMessage(this.tabName, true)
    },
    getAllTypesNewPersonMessageCount () {
      let self = this
      self.$http.get('/message/getAllTypesNewPersonMessageCount').then(function (res) {
        if (res.data) {
          self.tabCountStatistic = res.data
        }
      })
    },
    rowClassName (row, index) {
      if (row.state === 0) {
        return 'demo-table-error-row'
      } else {
        return 'demo-table-info-row'
      }
    },
    goOnNextStep (row) {
      let data = this.$constant.personMessageRouter
      if (row.type === 25) {
        this.alertDealSuccess(row)
      } else if (row.type === 66) {
        this.changeDirector(row)
      } else {
        this.$router.push({path: commonUtils.getUrlByTraceType(data, row.type), query: {row: row}})
      }
    },
    alertDealSuccess (row) {
      let self = this
      self.$Modal.confirm({
        title: '提示',
        content: row.content,
        width: 300,
        loading: false,
        okText: '已报名',
        cancelText: '未报名',
        onOk: () => {
          this.$router.push({path: '/order/fundPackageList'})
        },
        onCancel: () => {
          this.$router.push({path: '/user/addOrderFailRecords', query: {row: row}})
        }
      })
    },
    changeDirector (row) {
      let self = this
      self.$Modal.confirm({
        title: '提示',
        content: '您的该学员即将开课，是否转移学员至学导部门？',
        width: 300,
        loading: false,
        okText: '是',
        cancelText: '否',
        onOk: () => {
          this.openModal = true
          this.editData = row
        },
        onCancel: () => {
          this.$router.push({path: '/user/bindingValidTimeFailRecords', query: {row: row}})
        }
      })
    },
    updateTraceOperatorStatusAlert (row) {
      let self = this
      self.$Modal.confirm({
        title: '提示',
        content: '是否确认该信息后续操作已执行？确认后该条信息将不再提醒',
        width: 300,
        loading: false,
        okText: '是',
        cancelText: '否',
        onOk: () => {
          this.updateTraceOperatorStatus(row)
        },
        onCancel: () => {
        }
      })
    },
    closeImgModal () {
      this.showImgList = []
      this.showImgModal = false
    },
    viewPic (row) {
      this.showImgList = row.urls
      this.showImgModal = true
    },
    updateTraceOperatorStatus (row) {
      let self = this
      self.$http.post('/message/updateTraceOperatorStatus', {'personMessageId': row.id}).then(function (res) {
        if (res.data > 0) {
          self.$Message.success('操作成功!')
          self.getAllTypesNewPersonMessageCount()
          self.getMessage(self.tabName, true)
          bus.$emit('reloadMessageCount', 0)
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// PersonMessage.vue?1d339bcd